import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbstractHttpService } from "./http-abstract-service";
import { CloudflareResponse } from "./dto";

@Injectable({
	providedIn: "root",
})
export class HttpCloudflareService extends AbstractHttpService {
	constructor(http: HttpClient) {
		super(http, '/cloudflare-turnstile');
	}

	public verify(token: string): Observable<CloudflareResponse> {
		const path = `/verify`;
		return super.post<CloudflareResponse>(path, { token });
	}
}
